export default "__VITE_ASSET__e_Y8zZoO__"